import React, {useState, useRef} from 'react';
import {
    Modal,
    Button,
    Form,
    Radio,
    Select,
    Upload,
    Row,
    Col,
    message,
    Switch, Input, Divider
} from 'antd';
import {languages} from "../../constants";
import {InboxOutlined, ExclamationCircleOutlined} from '@ant-design/icons';
import {useAuth0} from "../../services/auth0";
import RequestedFile from './RequestFile';
import {Link, withRouter} from 'react-router-dom';
import {
    getPresignURLOupload,
    checkValidUserSubscription,
    downloadDriveFile,
    saveTranslationsRequest,
    initiateFileUpload,
    getPresignUrls,
    finishUploads,
    getExternalVideoDuration
} from "../../services/api.service";
import {Alert} from "reactstrap";
import {OverlayProgress} from "../../Component/OverlayPrgress/OverlayProgress";
import axios from "axios";
import {useRecoilState} from "recoil";
import {userDetails} from "../../recoil_store";
import {FilePicker} from "../../Component/FilePicker/FilePicker";
import mammoth from 'mammoth';

const {Dragger} = Upload;
const {confirm} = Modal;
const CancelToken = axios.CancelToken;

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 24},
};

const normFile = e => {
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
};

const fileRegex = /(.avi|.wmv|.flv|.mpg|.mp4|.mp3|.m4a|.doc|.txt|.docx|.mov|.pdf|.ppt|.pptx)$/;

const AddNewRequest = ({state, togelState, history}) => {
    const {user} = useAuth0();
    const [modalState, setState] = useState(state);
    const [submitLoader, setLoader] = useState(false);
    const [fileData, setFile] = useState([]);
    const [isDocFile, disableRadio] = useState(false);
    const [formFields, setFormFields] = useState([]);
    const [alert, showAlert] = useState(null);
    const [upgradeSuggestion, setUpgradeSuggestion] = useState([]);
    const [fileUploadProgress, setProgress] = useState(0);
    const [processText, setProcessText] = useState("");
    const [axiosRequests, setAxiosRequestToken] = useState([]);
    const [filePickerSelected, setPickerSelected] = useState(null);
    const [youtubeSwitch, setYoutubeSwitch] = useState(false);
    const [disableDrop, setDropDisable] = useState(false);
    const [isPDF, setPDF] = useState(false);
    const [isPPT, setPPT] = useState(false);
    const [requestForm] = Form.useForm();//form operations
    const filePickerRef = useRef();

    //recoil getter and updater
    const [currentUser, setUserDetails] = useRecoilState(userDetails);

    const props = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        onRemove: file => {
            setFile([]);
        },
        beforeUpload: file => {
            if (fileRegex.test(file.name.toLocaleString())) {
                setPickerSelected(false);
                // filePickerRef.current.clearSelectedFile();//todo uncomment after enable piker switch
                setFile([file]);
                const matchFileType = file.name.match(fileRegex)[0];
                const isMatched = !!(matchFileType === '.doc' || matchFileType === '.docx' || matchFileType === '.txt' || matchFileType === '.pdf'|| matchFileType === '.ppt' || matchFileType === '.pptx');
                const isPDF = !!(matchFileType === '.pdf');
                const isPPT = !!(matchFileType === '.ppt' || matchFileType === '.pptx');
                setPDF(isPDF);
                setPPT(isPPT)
                disableRadio(isMatched);
                setFormFields([
                    {
                        name: 'output',
                        value: isMatched ? '.txt' : ''
                    }
                ]);
            } else {
                message.warn('Please select audio,video,document or text file')
            }
            return false;
        }
    };

    /**
     * @name handleCancel
     * @description close popup modal
     * */
    const handleCancel = () => {
        // if (axiosRequests.length) {
        //     confirm({
        //         title: 'Do you want cancel request?',
        //         icon: <ExclamationCircleOutlined/>,
        //         onOk() {
        //             // debugger
        //             // const tokens = [...axiosRequests];
        //             // tokens.forEach(({source}) => {
        //             //     source.cancel('Operation canceled by the user.');
        //             // })
        //         },
        //         onCancel() {
        //             console.log('Cancel');
        //         },
        //     });
        // }
        togelState(false);
        setState(false);
    };

    /**
     * @name onRequestSubmit
     * @description form submit handler
     * */
    const onRequestSubmit = async (requestData) => {
        try {
            if (!fileData.length && !filePickerSelected) {
                message.error('Please select file to translate');
                return;
            }

            let driveDoc = null;
            if (!!filePickerSelected || youtubeSwitch) {
                if (filePickerSelected.isDocFile)
                    driveDoc = await downloadGoogleFile();
                else {
                    if (youtubeSwitch) {
                        confirm({
                            title: 'Please confirm that you own this youtube video, or that you have legal permission to use it',
                            icon: <ExclamationCircleOutlined/>,
                            okText: 'Confirm',
                            okType: 'danger',
                            onOk() {
                                setLoader(true);
                                setProcessText('Initiating request...');
                                externalFileRequest(requestData);
                            },
                            onCancel() {
                                console.log('Cancel');
                            },
                        });
                        return;
                    } else {
                        setLoader(true);
                        setProcessText('Initiating request...');
                        return await externalFileRequest(requestData);
                    }
                }
            }
            setLoader(true);
            setProcessText('Initiating request...');
            requestData.contentLength = await checkUserSubscriptionLimit(requestData.targetLanguage.length, driveDoc);
            setProcessText('Uploading file...');
            const presignUrlData = await fileUploading(fileData.length ? fileData[0] : driveDoc);
            // console.log('this is the presigned data: ', presignUrlData);
            //await uploadFile(presignUrlData, fileData.length ? fileData[0] : driveDoc);
            requestData.fileLink = `s3://${presignUrlData.fields.bucket}/${presignUrlData.fields.key}`;
            setProcessText('Saving translation request please wait...');
            const data = await requestTranslationRequest(requestData);
            updateSubscription(requestData.contentLength, requestData.targetLanguage.length);
            message.success('Request for message successfully created');
            setLoader(false);
            togelState(false, data);
        } catch (err) {
            console.log(err)
            setLoader(false);
            setProgress(0);
            setProcessText("");
            message.error('fail to process request');
        }
    };

    /**
     * @name externalFileRequest
     * @description make upload request for youtube video
     * */
    const externalFileRequest = async (requestData) => {
        try {
            let youtubeVideoId = "";
            if (youtubeSwitch) {
                const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?youtu\.?be(?:\.com)?\/?.*(?:watch|embed)?(?:.*v=|v\/|\/)([\w\-_]+)\&?/;
                const url = requestData.youtubeURL.split('v=');
                youtubeVideoId = requestData.youtubeURL.match(youtubeRegex)[1];
            }
            const {id, url, name} = filePickerSelected;
            const {data: {videoDetails}} = await getExternalVideoDuration(id || youtubeVideoId);
            requestData.contentLength = await checkUserSubscriptionLimit(requestData.targetLanguage.length, false, videoDetails.duration);
            requestData.isExternalVideo = true;
            setProcessText('Saving translation request please wait...');
            requestData.externalVideoData = {...videoDetails, id};
            const data = await requestTranslationRequest(requestData);
            updateSubscription(requestData.contentLength, requestData.targetLanguage.length);
            message.success('Request for message successfully created');
            setLoader(false);
            togelState(false, data);
        } catch (err) {
            console.log(err);
            setLoader(false);
            setProgress(0);
            setProcessText("");
            message.error("fail to process request");
        }
    }

    /**
     *@name updateSubscription
     * @description update local storage for plan details
     * */
    const updateSubscription = (contentLength, totalTargetLanguages) => {
        const user = JSON.parse(JSON.stringify(currentUser));
        const {filesLimit, totalMinutes, wordsLimit} = user.subscriptions;
        const newFilesLimit = filesLimit - totalTargetLanguages;
        if (!isDocFile) {
            const newTotalMinutes = totalMinutes - contentLength * totalTargetLanguages;
            user.subscriptions.totalMinutes = parseFloat(newTotalMinutes.toFixed(2));
        } else if (isDocFile) {
            const newTotalWords = wordsLimit - contentLength * totalTargetLanguages;
            user.subscriptions.wordsLimit = parseFloat(newTotalWords.toFixed(2));
        }
        user.subscriptions.filesLimit = newFilesLimit;
        setUserDetails({...user});
    }

    /**
     * @name removeAxiosToken
     * @description remove axios cancel token after success
     * */
    const removeAxiosToken = () => {
        const tokens = [...axiosRequests];
        tokens.shift();
        setAxiosRequestToken([...tokens]);
    }

    /**
     * @name getPresignUrl
     * @description presign s3 url for uploading files
     * */
    const getPresignUrl = async (selectedFile, token) => {
        try {
            const obj = {
                name: selectedFile.name.replace(/ +?/g, ''),
                type: selectedFile.type
            };
            const {data} = await getPresignURLOupload(obj, token);
            if (data.err) {
                throw new Error('Failed to send request')
            }
            return data.data;
        } catch (e) {
            throw new Error('Failed to send request')
        }
    };

    const fileUploading = async (file) => {
        try {
            const fileName = file.name.replace(/ +?/g, '');
            const axiosReq = axios.create();
            delete axiosReq.defaults.headers.put['Content-Type'];
            const {data: {uploadId}} = await initiateFileUpload({name: fileName});
            const FILE_CHUNK_SIZE = 10000000 // 10MB
            const NUM_CHUNKS = Math.floor(file.size / FILE_CHUNK_SIZE) + 1;
            const {data: {urls}} = await getPresignUrls({
                name: fileName,
                parts: NUM_CHUNKS,
                uploadId
            });
            setProcessText('Uploading file...');
            const keys = Object.keys(urls)
            const promises = []
            const selectedFiles = file;
            const uploadingTrack = {};

            for (const indexStr of keys) {
                const index = parseInt(indexStr);
                const start = index * FILE_CHUNK_SIZE
                const end = (index + 1) * FILE_CHUNK_SIZE
                const blob = index < keys.length ? selectedFiles.slice(start, end) : selectedFiles.slice(start);
                promises.push(axiosReq.put(urls[index], blob, {
                    onUploadProgress: progressEvent => {
                        const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                        if (totalLength !== null) {
                            // save the individual file's progress percentage in object
                            uploadingTrack[index + 1] = progressEvent.loaded * 100 / totalLength
                            // sum up all file progress percentages to calculate the overall progress
                            let totalPercent = Object.values(uploadingTrack).reduce((sum, num) => sum + num, 0) || 0
                            // divide the total percentage by the number of files
                            setProgress(parseInt(Math.round(totalPercent / urls.length)));
                            // setProgress(Math.round((progressEvent.loaded * 100) / totalLength));
                        }
                    }
                }))
            }

            const resParts = await Promise.all(promises);
            const result = resParts.map((part, index) => ({
                ETag: part.headers.etag,
                PartNumber: index + 1
            }))
            //to avoid memory leakage
            Object.keys(uploadingTrack).forEach((key) => {
                delete uploadingTrack[key]
            })
            const {data} = await finishUploads({name: fileName, parts: result, uploadId});
            return data;
        } catch (err) {
            throw err;
        }
    }

    /**
     * @name uploadFile
     * @description upload file to s3
     * */
    const uploadFile = async (s3Data, file, cancelToken) => {
        const formData = new FormData();
        Object.keys(s3Data.fields).forEach(key => {
            formData.append(key, s3Data.fields[key]);
        });
        formData.append("file", file);
        const config = {
            cancelToken,
            onUploadProgress: progressEvent => {
                const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
                if (totalLength !== null) {
                    setProgress(Math.round((progressEvent.loaded * 100) / totalLength));
                }
            }
        };
        return await axios.post(s3Data.url, formData, {
            ...config,
            headers: {'Content-Type': 'multipart/form-data'}
        })
    };

    /**
     * @name requestTranslationRequest
     * @description request transaction API call
     * */
    const requestTranslationRequest = async (reqData, token) => {
        try {
            const reqObj = {
                "email": user.email,
                "userID": user.sub.split('|')[1],
                "sourceLanguage": reqData.sourceLanguage,
                "languages": reqData.targetLanguage,
                "output": reqData.output,
                "fileLink": reqData.fileLink,
                "contentLength": reqData.contentLength,
                "isExternalVideo": !!reqData.isExternalVideo,
                isDocFile
            };
            if (filePickerSelected) {
                if (filePickerSelected.isDocFile)
                    reqObj.gDocMetaData = {...filePickerSelected}
                else
                    reqObj.externalVideoData = reqData.externalVideoData ? {...reqData.externalVideoData} : {...filePickerSelected};
            }
            const {data} = await saveTranslationsRequest(reqObj, token);
            if (data.error)
                throw new Error(data.error);
            else
                return data.data;
        } catch (err) {
            throw err;
        }
        // const reqResult = reqData.targetLanguage.map(language => {
        //     const reqObj = {
        //         "email": user.email,
        //         "userID": user.sub.split('|')[1],
        //         "sourceLanguage": reqData.sourceLanguage,
        //         "languages": reqData.targetLanguage,
        //         "output": reqData.output,
        //         "fileLink": reqData.fileLink,
        //         "duration": reqData.duration
        //     };
        //     return saveTranslationsRequest(reqObj, token);
        //     // const { data } = await saveTranslationsRequest(reqObj, token);
        //     // if (data.error)
        //     //     throw new Error(data.error);
        //     // else
        //     //     return data.data;
        // });
        // const resResult = await Promise.all(reqResult);
        // const result = resResult.map(({data: {data}}) => data)
        // return result;
    };

    /**
     * @name removeFileHandler
     * @description remove file from list
     * */
    const removeFileHandler = () => {
        setFile([]);
        requestForm.setFieldsValue({output: ''});
    };

    /**
     * @name checkUserSubscriptionLimit
     * @description check user have valid subscription before make request
     * */
    const checkUserSubscriptionLimit = async (contentLimit, driveFile, externalVideoDuration) => {
        try {
            let contentLength;
            if (externalVideoDuration)
                contentLength = externalVideoDuration * contentLimit;
            else {
                if (isPDF || isPPT) {
                    contentLength = 100; //hardcoding length of pdf and ppt documents; to-do: create mechanism to measure length of a ppt
                }  else {
                    contentLength = isDocFile ? await getDocumentLength(driveFile) : await getFileLength();
                }
            }
            
            await checkValidUserSubscription(contentLength * contentLimit, isDocFile);
            return contentLength;
        } catch (err) {
            console.log('this is the error in the user sub: ', err);
            const {data} = err.response;
            if (data) {
                if (data.isLimitExceeded) {
                    message.error(data.message);
                    data.isLimitExceeded && history.push('/payment');
                }
                if (data.isMediaLengthLimitExceeded) {
                    showAlert(data.message);
                    const plans = data.data.join(" or ");
                    const message = plans ? (
                        <React.Fragment>
                            to {plans} by <Link to="/payment">Payment</Link>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            by <a type="link" target="_blank" href="mailto:contact@paradi.io">Contact Us</a>
                        </React.Fragment>
                    )
                    setUpgradeSuggestion(message)
                }
            }
            throw err.response;
        }
    };

    /**
     * @name getFileLength
     * @description get audio or vide files length in minutes
     * */
    const getFileLength = async () => {
        return new Promise(resolve => {
            const myVideos = [];
            const files = fileData;
            myVideos.push(fileData[0]);
            const content = document.createElement(fileData[0].type.split('/')[0]);
            content.preload = 'metadata';

            content.onloadedmetadata = function () {
                window.URL.revokeObjectURL(content.src);
                myVideos[myVideos.length - 1].duration = content.duration;
                resolve(parseFloat((myVideos[myVideos.length - 1].duration / 60).toFixed(2)))
            };
            content.src = URL.createObjectURL(files[0]);
        });
    };


    /**
     * @name drivePickerHandler
     * @description set selected file from google file-picker
     * @param fileData
     * */
    const drivePickerHandler = async fileData => {
        requestForm.setFieldsValue({output: fileData && fileData.isDocFile ? '.txt' : ''});
        disableRadio(!!fileData && fileData.isDocFile);
        setPickerSelected(fileData);
        fileData && setFile([]);
        // debugger
        // const data = await getExternalVideoDuration(fileData.url);
        // console.log(data)
    }

    /**
     * @name downloadGoogleFile
     * @description download file form google drive
     * */
    const downloadGoogleFile = async () => {
        try {
            const {id, name} = filePickerSelected;
            const file = await downloadDriveFile(id);
            return new File([file.data], `${name}.docx`, {
                lastModified: new Date(),
                type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            });
        } catch (err) {
            throw err;
        }
    }

    const getDocumentLength = async (driveFile) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            const fileObj = fileData.length ? fileData[0] : driveFile;
            reader.onload = (loadEvent) => {
                const arrayBuffer = loadEvent.target.result;
                const fileType = fileObj.name.match(fileRegex)[0];
                if (fileType === '.txt') {
                    const binaryString = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
                    resolve(binaryString.length)
                } else {
                    mammoth.convertToHtml({arrayBuffer: arrayBuffer})
                        .then(displayResult => {
                            const string = displayResult.value.replace(/(<([^>]+)>)/ig, "");
                            resolve(string.length);
                        })
                        .catch(err => reject(err));
                }
            }
            reader.readAsArrayBuffer(fileObj);
        })
    }

    const onYoutubeSwitchChange = (data) => {
        setYoutubeSwitch(data);
        setPickerSelected(data);
    }

    const youtubeUrlChangeHandler = e => {
        setDropDisable(!!e.target.value);
        setYoutubeSwitch(!!e.target.value);
        setPickerSelected(!!e.target.value);
        // requestForm.setFieldsValue({output: ''});
    }

    return (
        <Modal
            visible={modalState}
            title="Add New Translation Request"
            width={900}
            maskClosable={false}
            onCancel={handleCancel}
            footer={[
                <Button style={{'display': submitLoader ? 'none' : ''}} form="request" key="submit" type="primary"
                        htmlType="submit" loading={submitLoader}>
                    Submit
                </Button>,
                <Button key="reset" onClick={handleCancel}>
                    Cancel
                </Button>
            ]}>
            {!submitLoader && (
                <Form
                    {...layout}
                    id="request"
                    fields={formFields}
                    form={requestForm}
                    name="requestForm"
                    onFinish={onRequestSubmit}>
                    {alert && (
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Alert color="warning">
                                    {alert} {upgradeSuggestion}.
                                </Alert>
                            </Col>
                        </Row>
                    )}
                    <Row gutter={[8, 8]}>
                        <Col lg={8} xs={24}>
                            <Form.Item name="youtubeURL"
                                       rules={
                                           [
                                               {required: !fileData.length, message: 'Please enter youtube video URL'},
                                               {type: 'url', message: 'Please enter valid URL'}
                                           ]
                                       }>
                                <Input placeholder="Youtube video URL"
                                       allowClear
                                       disabled={fileData.length}
                                       onChange={youtubeUrlChangeHandler}/>
                            </Form.Item>
                            <Divider>OR</Divider>
                            <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile}>
                                <Dragger disabled={!!filePickerSelected || disableDrop} {...props}
                                         accept={['audio/*', 'video/*', '.doc', '.docx', '.txt', '.pdf', '.ppt', '.pptx']}>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined/>
                                    </p>
                                    <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                    <p className="ant-upload-hint">
                                        Audio/video/Document/Text file only
                                    </p>
                                </Dragger>
                            </Form.Item>
                            {fileData.length ?
                                <RequestedFile fileName={fileData[0].name} removeFile={removeFileHandler}/> : null}
                        </Col>
                        <Col xs={24} lg={{span: 14, offset: 2}}>
                            {/*<Form.Item label="Upload video URL">*/}
                            {/*    <Switch disabled={fileData.length} onChange={onYoutubeSwitchChange}/>*/}
                            {/*</Form.Item>*/}
                            {/*{*/}
                            {/*    youtubeSwitch ? (*/}
                            {/*        <Form.Item disabled={fileData.length}*/}
                            {/*                   label="Youtube video URL"*/}
                            {/*                   name="youtubeURL"*/}
                            {/*                   rules={*/}
                            {/*                       [*/}
                            {/*                           {required: true, message: 'Please enter youtube video URL'},*/}
                            {/*                           {type: 'url', message: 'Please enter valid URL'}*/}
                            {/*                       ]*/}
                            {/*                   }>*/}
                            {/*            <Input placeholder="Youtube video URL"/>*/}
                            {/*        </Form.Item>*/}
                            {/*    ) : (*/}
                            {/*        <Form.Item label="Pick file from your drive" name="filePicker">*/}
                            {/*            <FilePicker disabled={fileData.length} ref={filePickerRef}*/}
                            {/*                        pickerData={drivePickerHandler}/>*/}
                            {/*        </Form.Item>*/}
                            {/*    )*/}
                            {/*}*/}
                            <Form.Item
                                label="Source Language"
                                name="sourceLanguage"
                                dependencies={['targetLanguage']}
                                rules={
                                    [{required: true, message: 'Please select source language!'}]
                                }
                            >
                                <Select placeholder="Select"
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {
                                        languages.map(({name, language}, key) =>
                                            <Select.Option value={language} key={key}>{name}</Select.Option>
                                        )
                                    }

                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Target Language"
                                name="targetLanguage"
                                dependencies={['sourceLanguage']}
                                rules={
                                    [
                                        {required: true, message: 'Please select target language!'},
                                        ({getFieldValue}) => ({
                                            validator(rule, value) {
                                                const sourceLanguage = getFieldValue('sourceLanguage');
                                                if (sourceLanguage) {
                                                    const index = value.indexOf(sourceLanguage);
                                                    if (index === -1) {
                                                        return Promise.resolve();
                                                    }
                                                    return Promise.reject('Source language and target language should not be same!');
                                                }
                                                return Promise.reject();
                                            },
                                        })
                                    ]
                                }
                            >
                                <Select placeholder="Select"
                                        mode="multiple"
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {
                                        languages.map(({name, language}, key) =>
                                            <Select.Option value={language} key={key}>{name}</Select.Option>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Output Type"
                                name="output"
                                rules={[{required: true, message: 'Please select output type!'}]}
                            >
                                <Radio.Group>
                                    <Radio disabled={isDocFile || !(fileData.length || filePickerSelected)}
                                           value=".srt">SRT</Radio>
                                    <Radio disabled={isDocFile || !(fileData.length || filePickerSelected)}
                                           value=".ttl">TTL</Radio>
                                    <Radio disabled={!isDocFile || !(fileData.length || filePickerSelected)}
                                           value=".txt">Text</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
            {submitLoader && <OverlayProgress text={processText} percentage={fileUploadProgress}/>}
        </Modal>
    )
};

export default withRouter(AddNewRequest);